<template>
    <div ref="map" id="map" class="map"></div>
</template>

<script>
export default {
  props: {
    lat: {
      required: true,
      type: String
    },
    lng: {
      required: true,
      type: String
    },
    zoom: {
      default: 14,
      type: String
    },
    address: {
      default : '',
      type: String
    },
    multiple: {
      default: '',
      type: String
    },
    otherPositions: {
      default: '',
      type: String,
    },
    otherAddresses: {
      default: '',
      type: String
    },
    shouldShowAddress: {
      default: false,
      type: Boolean
    }
  },
  mounted() {
    window.initMap = () => {
      let el = this.$refs.map;
      if (!el) {
        return;
      }
      let location = {
        lat: parseFloat(this.lat),
        lng: parseFloat(this.lng)
      };
      let address = this.address;
      let multiple = this.multiple;
      let shouldShowAddress = this.shouldShowAddress;
      let otherPositions = {}
      let otherAddresses = {}
      if (multiple) {
          otherPositions = JSON.parse(this.otherPositions);
          otherAddresses = JSON.parse(this.otherAddresses)
      }
      let map = new google.maps.Map(el, {
        zoom: parseInt(this.zoom),
        center: location,
        streetViewControl: false,
        fullscreenControl: false,
        mapTypeControl: false,
        zoomControlOptions: {
          position: google.maps.ControlPosition.LEFT_BOTTOM
        }
      });
      window.setTimeout(function() {
        if(address) {
          let infowindow = new google.maps.InfoWindow({
            content: '<div style="color: #000">' +  address + '</div>'
          });
          let marker= new google.maps.Marker({
            map: map,
            position: location,
            icon: window.markerIcon,
            animation: google.maps.Animation.DROP
          });
          if ( shouldShowAddress ) {
            setTimeout(function (){
              infowindow.open(map, marker);
            }, 600);
          } else {
            marker.addListener('click', function() {
              infowindow.open(map, marker);
            });
          }
        }
        if (multiple) {
          otherPositions.map( ( location , index) => {
            let infowindow = new google.maps.InfoWindow({
              content: '<div style="color: #000">' + otherAddresses[index] + '</div>'
            });
            let marker = new google.maps.Marker({
              map: map,
              position: location,
              icon: window.markerIcon,
              animation: google.maps.Animation.DROP
            });
            marker.addListener('click', function() {
              infowindow.open(map, marker);
            });
          });
          
        }
      }, 1400);
      
      map.setOptions({
        styles: [
          {
            elementType: "geometry",
            stylers: [{ color: "#131313" }]
          },
          {
            elementType: "labels.icon",
            stylers: [{ visibility: "off" }]
          },
          {
            elementType: "labels.text.stroke",
            stylers: [{ color: "#212121" }]
          },
          {
            featureType: "administrative.land_parcel",
            stylers: [{ visibility: "off" }]
          },
          {
            featureType: "administrative.locality",
            elementType: "labels.text.fill",
            stylers: [{ color: "#cccccc" }]
          },
          {
            featureType: "administrative.neighborhood",
            stylers: [{ visibility: "off" }]
          },
          {
            featureType: "poi",
            elementType: "labels.text",
            stylers: [{ visibility: "off" }]
          },
          {
            featureType: "poi.business",
            stylers: [{ visibility: "off" }]
          },
          {
            featureType: "poi.park",
            elementType: "geometry",
            stylers: [{ color: "#0C0C0C" }]
          },
          {
            featureType: "road",
            elementType: "labels.text.fill",
            stylers: [{ color: "#FFFFFF" }]
          },
          {
            featureType: "road",
            elementType: "labels.icon",
            stylers: [{ visibility: "off" }]
          },
          {
            featureType: "road.arterial",
            elementType: "geometry",
            stylers: [{ color: "#202020" }]
          },
          {
            featureType: "road.arterial",
            elementType: "labels",
            stylers: [{ visibility: "off" }]
          },
          {
            featureType: "road.highway",
            elementType: "geometry",
            stylers: [{ color: "#373737" }]
          },
          {
            featureType: "road.highway.controlled_access",
            elementType: "geometry",
            stylers: [{ color: "#373737" }]
          },
          {
            featureType: "road.local",
            stylers: [{ color: "#4b4b4b" }]
          },
          {
            featureType: "road.local",
            elementType: "labels.text.fill",
            stylers: [{ color: "#FFFFFF" }]
          },
          {
            featureType: "road.local",
            elementType: "labels.text.stroke",
            stylers: [{ color: "#212121" }]
          },
          {
            featureType: "transit",
            stylers: [{ visibility: "off" }]
          },
          {
            featureType: "water",
            elementType: "geometry",
            stylers: [{ color: "#000000" }]
          },
          {
            featureType: "water",
            elementType: "labels.text",
            stylers: [{ visibility: "off" }]
          }
        ]
      });
      window.onresize = function() {
        google.maps.event.trigger(map, "resize");
        map.setCenter(location);
      };
    };
    window.initMap();
  }
};
</script>


// WEBPACK FOOTER //
// assets/js/components/GoogleMap.vue